const USER_KEY = 'userDetailsAdmin';

export const getToken = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    const user = JSON.parse(raw);
    return user?.jwttoken ?? null;
  } catch {
    return null;
  }
};

export const getUserDetails = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setUserDetails = (userDetails) => {
  try {
    localStorage.setItem(USER_KEY, JSON.stringify(userDetails));
  } catch {
    // storage unavailable — ignore
  }
};

export const clearUserDetails = () => {
  localStorage.removeItem(USER_KEY);
};

export const getItem = (key) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return localStorage.getItem(key);
  }
};

export const setItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // storage unavailable — ignore
  }
};

export const removeItem = (key) => {
  localStorage.removeItem(key);
};

export const saveToken = (token) => {
  try {
    const user = getUserDetails() || {};
    user.jwttoken = token;
    setUserDetails(user);
  } catch {
    // storage unavailable — ignore
  }
};
